import type { MessageKey } from '../en';

export const pt: Partial<Record<MessageKey, string>> = {
  "defaults.accuracy.desc": "Precisão usada nos novos pontos do histórico",
  "defaults.accuracy.title": "Precisão GPS padrão",
  "defaults.actual.desc": "Usada para buscar lugares durante a simulação",
  "defaults.actual.empty": "Ainda não salva",
  "defaults.actual.emptyHint": "Permita a localização e abra o app sem simulação para capturá-la.",
  "defaults.actual.pending": "O telefone salva esta localização. A sincronização ainda não está conectada.",
  "defaults.actual.refresh": "Atualizar agora",
  "defaults.actual.title": "Sua localização real",
  "defaults.browserChip": "Este navegador",
  "defaults.close": "Fechar",
  "defaults.color.desc": "Cor da linha das novas rotas",
  "defaults.color.group": "Cor da rota",
  "defaults.color.title": "Cor da rota",
  "defaults.degrees": "{n}°",
  "defaults.format.dayMonthYear": "Data, ano · 12 h",
  "defaults.format.dayShort": "Dia e data · 12 h",
  "defaults.format.eu": "Data UE · 24 h",
  "defaults.format.fullDay": "Data completa · 12 h",
  "defaults.format.iso": "Data ISO · 24 h",
  "defaults.format.monthFirst": "Mês primeiro · 24 h",
  "defaults.format.shortDayYear": "Dia, data, ano · 24 h",
  "defaults.format.timeFirst": "Hora primeiro · 24 h",
  "defaults.format.us": "Data EUA · 12 h",
  "defaults.format.withSeconds": "Com segundos · 12 h",
  "defaults.itinAccuracy.desc": "Precisão GPS dos novos trechos",
  "defaults.itinAccuracy.title": "Precisão",
  "defaults.itinerary.desc": "Padrões para novos trechos",
  "defaults.itinerary.title": "Rota",
  "defaults.joyAccuracy.desc": "Precisão GPS inicial ao criar uma sessão de joystick",
  "defaults.joyAccuracy.title": "Precisão GPS padrão",
  "defaults.joyName.desc": "Nome padrão das novas sessões de joystick",
  "defaults.joyName.dialogTitle": "Escolher o formato do nome da sessão",
  "defaults.joyName.title": "Formato de data",
  "defaults.joySpeed.desc": "Velocidade inicial ao criar uma sessão de joystick",
  "defaults.joySpeed.title": "Velocidade padrão",
  "defaults.joyUnit.desc": "Mostra e ajusta as velocidades do joystick em km/h ou mph",
  "defaults.joystick.desc": "Padrões para sessões de joystick",
  "defaults.joystick.title": "Joystick",
  "defaults.kilometers": "{n} km",
  "defaults.map.desc": "Como os novos mapas abrem",
  "defaults.map.title": "Google Map",
  "defaults.mapTheme.desc": "Aparência das novas telas de mapa",
  "defaults.mapTheme.group": "Tema do mapa",
  "defaults.mapTheme.title": "Tema do mapa",
  "defaults.marker.car": "Carro",
  "defaults.marker.desc": "Usado ao criar uma sessão de joystick. Você pode mudá-lo em cada sessão.",
  "defaults.marker.group": "Marcador padrão",
  "defaults.marker.maps": "Maps",
  "defaults.marker.title": "Marcador padrão",
  "defaults.marker.waze": "Waze",
  "defaults.meters": "{n} m",
  "defaults.nameFormat.desc": "Nome padrão dos pontos fixos",
  "defaults.nameFormat.dialogSubtitle": "A prévia usa a data de hoje. Escolha um formato compacto para novos pontos.",
  "defaults.nameFormat.dialogTitle": "Escolher o formato do nome do ponto",
  "defaults.nameFormat.group": "Formato de data",
  "defaults.nameFormat.title": "Formato de data",
  "defaults.overlay.itinerary.desc": "Player flutuante quando a simulação da rota continua em segundo plano",
  "defaults.overlay.itinerary.title": "Rota automática",
  "defaults.overlay.joystick.desc": "Joystick flutuante quando a sessão continua em segundo plano",
  "defaults.overlay.joystick.title": "Joystick",
  "defaults.overlay.playlist.desc": "Player flutuante quando a simulação da lista continua em segundo plano",
  "defaults.overlay.playlist.title": "Lista",
  "defaults.overlay.stationary.desc": "Player flutuante quando a simulação fixa continua em segundo plano",
  "defaults.overlay.stationary.title": "Ponto fixo",
  "defaults.plAccuracy.desc": "Precisão GPS aplicada a cada pin da lista",
  "defaults.plAccuracy.title": "Precisão por item",
  "defaults.player.desc": "Controles do player sobreposto e da simulação",
  "defaults.player.title": "Player",
  "defaults.playlist.desc": "Padrões para novos pins de lista",
  "defaults.playlist.title": "Lista",
  "defaults.polyline.desc": "Cor padrão da rota desenhada durante uma sessão de joystick.",
  "defaults.polyline.group": "Cor da polilinha",
  "defaults.polyline.title": "Cor padrão da polilinha",
  "defaults.range.accuracyMax": "300 m",
  "defaults.range.accuracyMin": "0 m",
  "defaults.range.itinAccuracyMax": "100",
  "defaults.range.itinAccuracyMin": "1",
  "defaults.range.joyAccuracyMax": "100 m",
  "defaults.range.joyAccuracyMin": "1 m",
  "defaults.range.plAccuracyMax": "500 m",
  "defaults.range.plAccuracyMin": "0 m",
  "defaults.range.searchMax": "50 km",
  "defaults.range.searchMin": "3 km",
  "defaults.range.tiltMax": "65°",
  "defaults.range.tiltMin": "0°",
  "defaults.range.timeMax": "600 s",
  "defaults.range.timeMin": "0 s",
  "defaults.range.zoomMax": "20",
  "defaults.range.zoomMin": "10",
  "defaults.reset": "Redefinir",
  "defaults.search.itinerary": "Resultados próximos ao centro do mapa têm prioridade",
  "defaults.search.playlist": "Resultados próximos ao centro do mapa têm prioridade",
  "defaults.search.stationary": "Resultados próximos ao pin têm prioridade",
  "defaults.search.title": "Raio de busca",
  "defaults.seconds": "{n} s",
  "defaults.section.appearance": "Aparência",
  "defaults.section.camera": "Câmera",
  "defaults.section.history": "Histórico",
  "defaults.section.location": "Contexto de local",
  "defaults.section.map": "Mapa",
  "defaults.section.motion": "Movimento",
  "defaults.section.overlay": "Player sobreposto",
  "defaults.section.playlist": "Lista",
  "defaults.section.search": "Busca",
  "defaults.section.style": "Estilo",
  "defaults.section.view": "Mapa",
  "defaults.sectionDefaults": "Padrões do app",
  "defaults.sectionDefaultsDesc": "Defina padrões para uma experiência mais rápida e tranquila",
  "defaults.sectionPlayer": "Player",
  "defaults.sectionPlayerDesc": "Ajustes de sobreposição e reprodução",
  "defaults.speed.desc": "Velocidade de reprodução dos novos trechos",
  "defaults.speed.title": "Velocidade padrão",
  "defaults.speedValue": "{n} {unit}",
  "defaults.stationary.desc": "Padrões para novos pontos no mapa",
  "defaults.stationary.title": "Ponto fixo",
  "defaults.summary.playerAll": "Todas as sobreposições ativas",
  "defaults.summary.playerOff": "Sobreposições desativadas",
  "defaults.summary.playerSome": "{on} de 4 ativas",
  "defaults.summary.zoom": "zoom {n}",
  "defaults.syncNote": "Salvo neste navegador por enquanto. O app do telefone usará estes valores quando a sincronização estiver conectada.",
  "defaults.theme.night": "Noite",
  "defaults.theme.nightDesc": "Cores escuras do mapa para pouca luz e sessões noturnas.",
  "defaults.theme.retro": "Retrô",
  "defaults.theme.retroDesc": "Tons quentes vintage, com jeito de mapa clássico.",
  "defaults.theme.silver": "Prata",
  "defaults.theme.silverDesc": "Cinza claro, agradável à luz do dia.",
  "defaults.theme.standard": "Padrão",
  "defaults.theme.standardDesc": "Cores clássicas do Google Maps, com verdes e azuis familiares.",
  "defaults.tilt.desc": "Ângulo da câmera nas telas de mapa",
  "defaults.tilt.title": "Inclinação padrão da câmera",
  "defaults.time.desc": "Espera antes de ir para o próximo pin",
  "defaults.time.title": "Tempo por item",
  "defaults.tray.group": "Altura da bandeja",
  "defaults.tray.large": "Grande",
  "defaults.tray.medium": "Média",
  "defaults.tray.playlistDesc": "Painel de listas visível no mapa",
  "defaults.tray.small": "Pequena",
  "defaults.tray.stationaryDesc": "Tamanho visível do painel no mapa",
  "defaults.tray.title": "Altura da bandeja",
  "defaults.unit.group": "Unidade de velocidade",
  "defaults.unit.itineraryDesc": "Mostra velocidades em km/h ou mph no módulo de rota",
  "defaults.unit.kmh": "km/h",
  "defaults.unit.mph": "mph",
  "defaults.unit.title": "Unidade de velocidade",
  "defaults.view.grid": "Grade",
  "defaults.view.group": "Visualização",
  "defaults.view.historyDesc": "Como os pontos salvos aparecem",
  "defaults.view.historyTitle": "Visualização do histórico",
  "defaults.view.list": "Lista",
  "defaults.view.playlistDesc": "Como as listas salvas aparecem",
  "defaults.view.playlistTitle": "Visualização das listas",
  "defaults.zoom.desc": "Zoom inicial dos novos mapas",
  "defaults.zoom.title": "Nível de zoom padrão",
  "language.defaultBadge": "Padrão",
  "language.empty": "Nenhum idioma corresponde a esta busca.",
  "language.lead": "Inglês (Estados Unidos) é o idioma padrão. Sua escolha fica salva neste navegador.",
  "language.listLabel": "Idiomas",
  "language.preview": "Locais simulados, listas e rotas.",
  "language.previewLabel": "Prévia",
  "language.searchLabel": "Buscar idiomas",
  "language.searchPlaceholder": "Buscar idiomas",
  "nav.account": "Conta",
  "nav.account.desc": "Perfil, Premium e acesso.",
  "nav.analytics": "Análises",
  "nav.analytics.desc": "Entenda a atividade no MockLoc, o uso da rede e o estado da sincronização.",
  "nav.articles": "Artigos",
  "nav.articles.desc": "Guias de configuração, reprodução e sincronização.",
  "nav.backup": "Backup e sincronização",
  "nav.backup.desc": "Status do backup na nuvem e da sincronização.",
  "nav.coins": "Mock Coins",
  "nav.coins.desc": "Detalhamento completo do uso de moedas por módulo e atividade.",
  "nav.dashboard": "Painel",
  "nav.dashboard.desc": "Visão geral de locais, listas, rotas e atividade da conta.",
  "nav.devices": "Gerenciar dispositivos",
  "nav.devices.desc": "Veja os dispositivos conectados à sua conta MockLoc.",
  "nav.help": "Ajuda e suporte",
  "nav.help.desc": "Acompanhe conversas e peça ajuda à equipe MockLoc.",
  "nav.history": "Histórico de locais",
  "nav.history.desc": "Lugares que esta conta simulou.",
  "nav.itinerary": "Rotas",
  "nav.itinerary.desc": "Crie, edite e gerencie as rotas salvas.",
  "nav.joystick": "Sessões de joystick",
  "nav.joystick.desc": "Rotas de reprodução, estatísticas e sessões de joystick salvas.",
  "nav.notifications": "Notificações",
  "nav.notifications.desc": "Avisos de sincronização, backup e produto.",
  "nav.playlist": "Listas",
  "nav.playlist.desc": "Conjuntos ordenados de locais simulados.",
  "nav.settings": "Configurações",
  "nav.settings.desc": "Tema, idioma e padrões do app móvel.",
  "nav.stationary": "Pontos fixos",
  "nav.stationary.desc": "Locais simulados fixos salvos nesta conta.",
  "nav.whatsNew": "Novidades do app",
  "nav.whatsNew.desc": "Novas atualizações, correções e melhorias no MockLoc.",
  "settings.back": "Configurações",
  "settings.backDefaults": "Padrões do app",
  "settings.defaults.shellDesc": "Valores que o app do telefone usa para mapas, pontos, rotas e reprodução.",
  "settings.defaults.shellTitle": "Padrões do app",
  "settings.home.defaults.desc": "Padrões de mapa, ponto, lista, rota, joystick e player do app do telefone.",
  "settings.home.defaults.title": "Padrões do app",
  "settings.home.language.desc": "Escolha o idioma do menu, dos títulos e das configurações.",
  "settings.home.language.title": "Configurações de idioma",
  "settings.home.theme.desc": "Tamanho do texto, cores, claro ou escuro e fonte deste navegador.",
  "settings.home.theme.title": "Configurações de tema",
  "settings.language.shellDesc": "Escolha o idioma deste site.",
  "settings.language.shellTitle": "Idioma",
  "settings.theme.shellDesc": "Tamanho do texto, cores, claro ou escuro e fonte deste navegador.",
  "settings.theme.shellTitle": "Tema",
  "shell.account": "Conta",
  "shell.accountMenu": "Menu da conta",
  "shell.accountMenuNamed": "Menu da conta, {name}",
  "shell.closeMenu": "Fechar menu",
  "shell.collapseSidebar": "Recolher barra lateral",
  "shell.dashboardSubtitle": "Gerencie locais simulados, listas, rotas e mais em um só lugar.",
  "shell.devicesLimit": "Uso em até 3 dispositivos",
  "shell.expandSidebar": "Expandir barra lateral",
  "shell.goPremium": "Assinar Premium",
  "shell.logOut": "Sair",
  "shell.mainNav": "Navegação principal",
  "shell.noMatches": "Nenhum resultado",
  "shell.notifications": "Notificações",
  "shell.notificationsUnread": "Notificações, {count} não lidas",
  "shell.openMenu": "Abrir menu",
  "shell.pages": "Páginas",
  "shell.recent": "Recentes",
  "shell.searchLabel": "Buscar locais, listas, rotas, artigos",
  "shell.searchPlaceholder": "Buscar locais, listas, rotas, artigos...",
  "shell.searchResults": "Resultados da busca",
  "shell.tagline": "Localização simulada, de forma simples",
  "shell.themeDarkTitle": "Tema escuro",
  "shell.themeLightTitle": "Tema claro",
  "shell.themeToDark": "Mudar para o tema escuro",
  "shell.themeToLight": "Mudar para o tema claro",
  "shell.there": "você",
  "shell.unlimitedCoins": "Moedas ilimitadas",
  "shell.unlimitedEverything": "Tudo ilimitado",
  "shell.upgradeNow": "Fazer upgrade agora",
  "shell.viewAllNotifications": "Ver todas as notificações",
  "shell.welcome": "Bem-vindo de volta, {name}!",
  "theme.builtin": "Integrada",
  "theme.changesLabel": "O que muda.",
  "theme.color.accent.changes": "Dourado da marca e fundos dourados claros, inclusive pequenos detalhes das ilustrações.",
  "theme.color.accent.title": "Destaque",
  "theme.color.accent.where": "Destaques dourados no acesso, nos artigos e nos selos.",
  "theme.color.danger.changes": "Texto de erro vermelho e ações destrutivas.",
  "theme.color.danger.title": "Perigo",
  "theme.color.danger.where": "Erros, remoções e o ponto de não lido.",
  "theme.color.info.changes": "O azul usado para informação no claro e no escuro.",
  "theme.color.info.title": "Info",
  "theme.color.info.where": "Estado azul, links de informação e marcas de info.",
  "theme.color.lead": "As cores integradas continuam diferentes no claro e no escuro até você escolher uma. Sua escolha vale nos dois temas. Cores salvas em um ponto, uma lista ou uma rota permanecem salvas.",
  "theme.color.primary.changes": "Roxo sólido, texto roxo claro e fundos roxos suaves.",
  "theme.color.primary.title": "Primária",
  "theme.color.primary.where": "Botões, item de menu ativo, links e o roxo da marca.",
  "theme.color.success.changes": "Texto de estado verde e marcas de sucesso.",
  "theme.color.success.title": "Sucesso",
  "theme.color.success.where": "Sincronizado, concluído e estado positivo.",
  "theme.color.title": "Cor",
  "theme.color.warning.changes": "Avisos âmbar e o dourado usado nas moedas.",
  "theme.color.warning.title": "Aviso",
  "theme.color.warning.where": "Alertas, marcas de moedas e destaques Premium.",
  "theme.colorAria": "Cor {title}",
  "theme.custom": "Personalizada",
  "theme.face.arialBold": "Arial Bold",
  "theme.face.arialRegular": "Arial Regular",
  "theme.face.arialSynth": "Sintetizado a partir de Arial",
  "theme.face.gsBold": "Google Sans Bold",
  "theme.face.gsRegular": "Google Sans Regular",
  "theme.face.helveticaOther": "Helvetica ou sintetizado",
  "theme.face.helveticaRegular": "Helvetica Regular",
  "theme.face.inter": "Inter {weight}",
  "theme.font.arial.note": "Regular e Bold são fontes instaladas. Os outros pesos são sintetizados.",
  "theme.font.google-sans.note": "O arquivo Regular cobre 400 e 500. O arquivo Bold cobre de 600 a 900.",
  "theme.font.group": "Fonte",
  "theme.font.helvetica.note": "Usa Helvetica neste dispositivo, depois Helvetica Neue e depois Arial.",
  "theme.font.inter.note": "Fonte que o site usa hoje. De Regular a Black estão carregadas.",
  "theme.font.lead": "Uma família vale para o site inteiro. Títulos de marketing voltam para Plus Jakarta Sans quando Inter está escolhida. Os pesos abaixo são os que a interface já usa.",
  "theme.font.sample": "Localização simulada, de forma simples",
  "theme.font.title": "Fonte",
  "theme.hexAria": "Hex {title}",
  "theme.lead": "Escolha o tamanho do texto, a cor, claro ou escuro e a fonte deste navegador. 100 % corresponde às telas de hoje. Os exemplos aqui, e o restante do site, mudam juntos.",
  "theme.manager": "Gerenciamento de tema",
  "theme.mode.dark": "Escuro",
  "theme.mode.darkHint": "Superfícies escuras e texto claro.",
  "theme.mode.group": "Tema",
  "theme.mode.lead": "A mesma escolha claro ou escuro do botão na barra superior.",
  "theme.mode.light": "Claro",
  "theme.mode.lightHint": "Superfícies claras e texto escuro.",
  "theme.mode.title": "Tema",
  "theme.previewBody": "Locais salvos nesta conta.",
  "theme.previewBold": "Lista pronta",
  "theme.previewHelp": "Conjuntos ordenados de locais simulados.",
  "theme.previewKicker": "Prévia ao vivo",
  "theme.previewTitle": "Locais simulados",
  "theme.reset": "Redefinir",
  "theme.resetAll": "Redefinir tudo",
  "theme.resetColors": "Redefinir cores",
  "theme.resetFont": "Redefinir fonte",
  "theme.resetText": "Redefinir texto",
  "theme.sizeAria": "Tamanho de {title}",
  "theme.text.bold.changes": "Texto de 15 px a 18 px.",
  "theme.text.bold.sample": "Assinar Premium",
  "theme.text.bold.title": "Negrito",
  "theme.text.bold.where": "Títulos de cartão, nome da marca, títulos de seção e botões grandes.",
  "theme.text.descriptive.changes": "Texto de 12 px a 13 px.",
  "theme.text.descriptive.sample": "Conjuntos ordenados de locais simulados.",
  "theme.text.descriptive.title": "Descritivo",
  "theme.text.descriptive.where": "Legendas, texto de ajuda, selos, rodapés e linhas secundárias.",
  "theme.text.header.changes": "Texto de 20 px ou mais.",
  "theme.text.header.sample": "Pontos fixos",
  "theme.text.header.title": "Cabeçalho",
  "theme.text.header.where": "Títulos de página, títulos grandes, títulos de estado vazio e números grandes, como saldos de moedas.",
  "theme.text.lead": "Cada papel tem um tamanho compartilhado. O exemplo mostra esse papel. Os controles desta página ficam em tamanho fixo para continuar fáceis de usar.",
  "theme.text.normal.changes": "Texto de 14 px.",
  "theme.text.normal.sample": "Locais salvos nesta conta.",
  "theme.text.normal.title": "Normal",
  "theme.text.normal.where": "Rótulos de navegação, botões padrão, títulos de lista e resumos curtos.",
  "theme.text.other.changes": "Texto de 9 px a 11 px. Marcas abaixo de 9 px ficam fixas.",
  "theme.text.other.sample": "Atualizado há 2 horas",
  "theme.text.other.title": "Outro",
  "theme.text.other.where": "Rótulos pequenos, horários, rótulos de gráfico e legendas.",
  "theme.text.title": "Texto",
  "theme.weight.black": "Black",
  "theme.weight.bold": "Bold",
  "theme.weight.extrabold": "Extra bold",
  "theme.weight.medium": "Medium",
  "theme.weight.regular": "Regular",
  "theme.weight.sample": "Locais simulados, listas e rotas",
  "theme.weight.semibold": "Semibold",
  "theme.whereLabel": "Onde é usado.",
};
